import { useEffect } from 'react'
import { siteContent, socialLinks } from '../content/siteContent'
import type { SeoContent } from '../types'

function setMeta(selector: string, attribute: string, value: string) {
  let element = document.head.querySelector<HTMLMetaElement>(selector)
  if (!element) {
    element = document.createElement('meta')
    const [name, key] = selector.includes('property=') ? ['property', selector.match(/"(.+)"/)?.[1]] : ['name', selector.match(/"(.+)"/)?.[1]]
    if (key) element.setAttribute(name, key)
    document.head.appendChild(element)
  }
  element.setAttribute(attribute, value)
}

export function DocumentMeta({ title, description, path }: SeoContent) {
  useEffect(() => {
    const canonicalUrl = `${siteContent.siteUrl}${path === '/' ? '' : path}`
    document.title = title
    setMeta('meta[name="description"]', 'content', description)
    setMeta('meta[property="og:title"]', 'content', title)
    setMeta('meta[property="og:description"]', 'content', description)
    setMeta('meta[property="og:type"]', 'content', 'website')
    setMeta('meta[property="og:url"]', 'content', canonicalUrl)
    let canonical = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]')
    if (!canonical) {
      canonical = document.createElement('link')
      canonical.rel = 'canonical'
      document.head.appendChild(canonical)
    }
    canonical.href = canonicalUrl
    let structuredData = document.head.querySelector<HTMLScriptElement>('#site-structured-data')
    if (!structuredData) {
      structuredData = document.createElement('script')
      structuredData.id = 'site-structured-data'
      structuredData.type = 'application/ld+json'
      document.head.appendChild(structuredData)
    }
    structuredData.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'Person',
      name: siteContent.name,
      url: siteContent.siteUrl,
      email: siteContent.email,
      jobTitle: 'Wokalistka i trener wokalny',
      sameAs: socialLinks.map((social) => social.href),
      knowsAbout: ['Oprawa wokalna ślubu', 'Lekcje śpiewu', 'Trening wokalny'],
    })
  }, [description, path, title])
  return null
}
